const CognitoConfig = {
    Auth: {
        region: 'ap-southeast-1',
        userPoolId: 'ap-southeast-1_YjQGxMAvE',
        userPoolWebClientId: '1tc9k6u8041phlnmuetl1aon3b',
   }
}

export default CognitoConfig;